import { useState } from 'react';
import './ModalRegister.css';

function ModalRegister() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [otpSent, setOtpSent] = useState(false);

  const handleSendOtp = (e) => {
    e.preventDefault();
    if (!phoneNumber) {
      setError('Please enter your mobile number');
      return;
    }
    if (!/^\d{10}$/.test(phoneNumber)) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }
    setError('');
    setOtpSent(true);
    console.log('OTP sent to:', `+91${phoneNumber}`);
    
    setTimeout(() => {
      setOtpSent(false);
      console.log('OTP sending simulation complete');
    }, 2000);
  };

  return (
    <div className="modal-register-container">
      <div className="modal-register-box">
        <div className="modal-register-header">
          <h2>Continue with Mobile</h2>
        </div>
        {error && <p className="modal-register-error">{error}</p>}
        {otpSent && <p className="modal-register-success">OTP sent successfully!</p>}
        <form className="modal-register-form">
          <div className="modal-register-phone-container">
            <span className="modal-register-phone-prefix">+91</span>
            <input
              type="tel"
              placeholder="Enter your mobile number"
              className="modal-register-phone-input"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              maxLength="10"
            />
          </div>
        </form>
        <button type="button" onClick={handleSendOtp} className="modal-register-send-otp-btn">
          Send OTP
        </button>
      </div>
    </div>
  );
}

export default ModalRegister;